"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();